import { mergeTemplate } from './base-template';

export const eventsTemplate = mergeTemplate({
  name: 'Events & Catering',
  icon: '🎉',
  settings: {
    primaryColor: '#1a5d53',
    accentColor: '#f472b6',
    fontStack: 'spark',
    stylePreset: 'gasserwerk',
    pageAngebot: {
      heroTitle: 'Unsere Event-Pakete',
      heroSubtitle: 'Für jeden Anlass das passende Konzept',
      packages: [
        { name: 'Private Feiern', price: "ab CHF 1'500", description: 'Geburtstage, Jubiläen, Familienanlässe', features: 'Location-Beratung, Menüplanung, Dekoration, Service, Musik', highlighted: false },
        { name: 'Firmenevents', price: "ab CHF 5'000", description: 'Seminare, Teambuilding, Firmenfeiern', features: 'Konzeptentwicklung, Catering, Technik, Moderation, Eventlogistik', highlighted: true },
        { name: 'Hochzeiten', price: "ab CHF 8'000", description: 'Der schönste Tag perfekt geplant', features: 'Komplettplanung, Location, Catering, Blumen, Musik, Koordination am Tag', highlighted: false },
      ],
      ctaTitle: 'Ihr Event, unsere Leidenschaft',
      ctaText: 'Erzählen Sie uns von Ihrem Anlass — wir machen etwas Besonderes daraus.',
      ctaButtonText: 'Unverbindlich anfragen',
    },
    pageMethoden: {
      heroTitle: 'So planen wir Ihr Event',
      heroSubtitle: 'Vom Briefing bis zum letzten Gast',
      introText: 'Jeder Event ist ein Unikat. Wir planen mit Herzblut, organisieren mit System und führen durch mit Gelassenheit.',
      steps: [
        { title: 'Briefing', description: 'Ihre Wünsche, Ihr Budget, Ihre Vision — wir hören genau zu' },
        { title: 'Konzept', description: 'Kreative Ideen, realistische Planung, transparente Kosten' },
        { title: 'Organisation', description: 'Koordination aller Partner, Logistik und Details' },
        { title: 'Durchführung', description: 'Professionelle Umsetzung — Sie geniessen, wir kümmern uns' },
      ],
      tools: [
        { name: 'Event-Management-Software', description: 'Professionelle Planung und Koordination' },
        { name: 'Partner-Netzwerk', description: 'Bewährte Locations, Caterer und Dienstleister' },
        { name: 'Budget-Transparenz', description: 'Detaillierte Kostenplanung ohne Überraschungen' },
      ],
      philosophyTitle: 'Unsere Event-Philosophie',
      philosophyText: 'Ein guter Event ist wie ein gutes Essen — die Gäste merken nicht, wie viel Arbeit dahintersteckt.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Kreativität trifft Organisation',
      introText: 'Unser Team aus Eventprofis plant und realisiert Anlässe mit Leidenschaft und Erfahrung.',
      imageUrl: '',
      timeline: [
        { year: '2011', text: 'Gründung als Catering-Service' },
        { year: '2016', text: 'Erweiterung um Full-Service Eventplanung' },
        { year: '2022', text: 'Über 500 erfolgreich durchgeführte Events' },
      ],
      values: [
        { title: 'Kreativität', description: 'Jeder Event verdient eine einzigartige Note' },
        { title: 'Zuverlässigkeit', description: 'Perfekte Organisation bis ins letzte Detail' },
        { title: 'Leidenschaft', description: 'Wir lieben, was wir tun — das spürt man' },
      ],
      certifications: 'GastroSuisse, Swiss Event Association',
    },
  },
  components: {
    header: {
      companyName: 'Events Muster',
      logoText: 'EM',
      navItems: ['Pakete', 'Konzept', 'Team', 'Kontakt'],
      ctaText: 'Anfrage starten',
    },
    hero: {
      title: 'Momente. Die bleiben.',
      subtitle:
        'Eventplanung und Catering – kreativ, zuverlässig, massgeschneidert.',
      primaryBtn: 'Anfrage starten',
      secondaryBtn: 'Anlässe',
      imageUrl: '',
    },
    trust: {
      items: [
        { value: 'Kreativ', label: 'Konzepte' },
        { value: 'Zuverlässig', label: 'Umsetzung' },
        { value: 'Regional', label: 'Produkte' },
        { value: 'Flexibel', label: 'Grössen' },
      ],
    },
    services: {
      title: 'Anlässe',
      subtitle: 'Von intim bis gross.',
      items: [
        {
          icon: '🍾',
          title: 'Private Events',
          text: 'Geburtstage, Hochzeiten, Jubiläen.',
        },
        {
          icon: '🏢',
          title: 'Business Events',
          text: 'Seminare, Apéros, Firmenanlässe.',
        },
        {
          icon: '🍽️',
          title: 'Catering',
          text: 'Flying Buffet, Menü, individuelle Konzepte.',
        },
      ],
    },
    process: {
      title: 'So läuft es ab',
      subtitle: '',
      steps: [
        {
          num: '1',
          title: 'Briefing',
          text: 'Anlass, Gästeanzahl, Budget, Wünsche.',
        },
        {
          num: '2',
          title: 'Konzept',
          text: 'Menü, Ablauf, Location-Check.',
        },
        {
          num: '3',
          title: 'Umsetzung',
          text: 'Koordination, Aufbau, Service.',
        },
        {
          num: '4',
          title: 'Nachbereitung',
          text: 'Abbau, Feedback, Rechnung.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Kreativität trifft Organisation.',
      members: [
        {
          name: 'Fabienne Gerber',
          role: 'Inhaberin & Event-Managerin',
          image: '',
          bio: 'Über 10 Jahre Erfahrung in der Eventplanung. Spezialistin für Hochzeiten und Firmenanlässe.',
        },
        {
          name: 'Raphael Moser',
          role: 'Catering-Leiter & Koch',
          image: '',
          bio: 'Gelernt in der Spitzengastronomie. Regionale Küche mit kreativer Note.',
        },
      ],
    },
    testimonials: {
      title: 'Feedback',
      items: [
        {
          quote:
            'Alles hat perfekt geklappt — unsere Gäste schwärmen heute noch.',
          author: 'Anna & David Wyss',
          role: 'Hochzeit, Schloss Rapperswil',
        },
        {
          quote: 'Der Firmenapéro war ein voller Erfolg. Professionell, kreativ und unkompliziert in der Zusammenarbeit.',
          author: 'Martina Fischer',
          role: 'HR-Leiterin, Technologiefirma Zürich',
        },
        {
          quote: 'Von der Planung bis zum Abbau — alles aus einer Hand und alles perfekt. Vielen Dank!',
          author: 'Thomas Aebischer',
          role: 'Jubiläumsfeier, 50. Geburtstag',
        },
        {
          quote: 'Das Catering war hervorragend. Frische, regionale Produkte und eine tolle Präsentation.',
          author: 'Silvia Brunner',
          role: 'Geschäftsführerin, Seminarhotel',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Wie früh muss ich anfragen?',
          answer:
            'Idealerweise 2 bis 3 Monate im Voraus, bei Hochzeiten gerne 6 bis 12 Monate. Kurzfristige Anfragen prüfen wir aber gerne.',
        },
        {
          question: 'Was kosten Ihre Event-Pakete?',
          answer:
            'Private Feiern starten ab CHF 1\'500, Firmenevents ab CHF 5\'000 und Hochzeiten ab CHF 8\'000. Jedes Paket wird individuell auf Ihre Wünsche angepasst.',
        },
        {
          question: 'Können Sie auch vegetarisches oder veganes Catering anbieten?',
          answer:
            'Selbstverständlich. Wir bieten vollwertige vegetarische und vegane Menüs an und gehen auch auf Allergien und Unverträglichkeiten ein.',
        },
      ],
    },
    cta: {
      title: 'Anfrage starten',
      subtitle:
        'Schildern Sie Ihren Anlass – wir melden uns mit ersten Ideen.',
      phone: '+41 00 000 00 00',
      email: 'events@example.ch',
    },
    footer: {
      companyName: 'Events Muster',
      tagline: 'Events & Catering in Ihrer Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'events@example.ch',
    },
  },
});
